import { WeaveButton } from '../UI/WeaveButton/WeaveButton';
import { WeaveInput } from '../UI/WeaveInput/WeaveInput';
import { useWindowSettingsStore } from '@/store/windowSettingsStore';
import styles from './styles.module.scss';
import { useThreeSceneStore } from '@/store/threeSceneStore';
import { WeaveToggle } from '../UI/WeaveToggle/WeaveToggle';
import { useWorkflowStore } from '@/store/workflowStore';
import { useViewFeaturesStore } from '@/store/viewFeaturesStore';

export const WindowSettings = () => {
	const {
		isHoleCreationMode,
		setIsHoleCreationMode,
		isHoleDeletionMode,
		setIsHoleDeletionMode
	} = useThreeSceneStore();
	const {
		resetAllModes,
	} = useViewFeaturesStore();

	const { currentStage } = useWorkflowStore();

	const {
		windowSizePercent,
		setWindowSizePercent,
		windowSizeInMeters,
		setWindowSizeInMeters,
		snapPointDistance,
		setSnapPointDistance,
		windowSizeUnit,
		setWindowSizeUnit,
	} = useWindowSettingsStore();

	const handleWindowSizeChange = (e: React.FormEvent<HTMLElement>) => {
		const target = e.target as HTMLInputElement;
		const percent = parseFloat(target.value);
		if (!isNaN(percent) && percent >= 0 && percent <= 100) {
			setWindowSizePercent(percent);
		}
	};

	const handleWindowHeightChange = (e: React.FormEvent<HTMLElement>) => {
		const target = e.target as HTMLInputElement;
		const height = parseFloat(target.value);
		if (!isNaN(height) && height >= 0 && height <= 100) {
			setWindowSizeInMeters(windowSizeInMeters.width, height);
		}
	};

	const handleWindowWidthChange = (e: React.FormEvent<HTMLElement>) => {
		const target = e.target as HTMLInputElement;
		const width = parseFloat(target.value);
		if (!isNaN(width) && width >= 0 && width <= 100) {
			setWindowSizeInMeters(width, windowSizeInMeters.height);
		}
	};

	const handleSnapPointDistanceChange = (e: React.FormEvent<HTMLElement>) => {
		const target = e.target as HTMLInputElement;
		const distance = parseFloat(target.value);
		if (!isNaN(distance) && distance >= 0 && distance <= 10) {
			setSnapPointDistance(distance);
		}
	};

	const handleToggleChange = (e: unknown) => {
		const event = e as {
			nativeEvent: { detail: { checked: boolean } };
		};

		const isChecked = event.nativeEvent.detail.checked;
		setWindowSizeUnit(isChecked ? 'meters' : 'percent');
	};

	if (currentStage === 'predesign_programming') {
		return (
			<div>
				<p>Windows & Openings settings will be available from Gate 2.</p>
			</div>
		);
	}

	return (
		<div className={styles.windowSettings}>
			<div className={styles.buttonsRow}>
				<WeaveButton
					onClick={() => {
						setIsHoleCreationMode(!isHoleCreationMode);
						resetAllModes();
					}}
					variant={isHoleCreationMode ? 'solid' : 'outlined'}
				>
					Add Windows
				</WeaveButton>
				<WeaveButton
					onClick={() => {
						setIsHoleDeletionMode(!isHoleDeletionMode);
						resetAllModes();
					}}
					variant={isHoleDeletionMode ? 'solid' : 'outlined'}
				>
					Delete Window
				</WeaveButton>
			</div>
			<div className={styles.sizeControl}>
				<div className={styles.windowSettingsHeader}>
					<label>
						Snap Interval (m):{' '}
						<WeaveInput
							id="snapInterval"
							type="number"
							min={0}
							max={10}
							step="0.05"
							value={snapPointDistance.toString()}
							onChange={handleSnapPointDistanceChange}
						/>
					</label>
					<label className={styles.toggleLabel}>
						Use fixed window size: {' '}
						<WeaveToggle toggled={windowSizeUnit === 'meters'} onChange={handleToggleChange} />
					</label>
				</div>
				{windowSizeUnit === 'percent' ? (
					<div className={styles.sizeInput}>
						<label>
							Window Size (% of wall):{' '}
							<WeaveInput
								id="windowSize"
								type="number"
								min={0}
								max={100}
								step="5"
								value={windowSizePercent.toString()}
								onChange={handleWindowSizeChange}
							/>
						</label>
					</div>
				) : (
					<div className={styles.sizeInput}>
						<label>
							Window Width (m):{' '}
							<WeaveInput
								id="windowWidth"
								type="number"
								min={0}
								max={100}
								step="5"
								value={windowSizeInMeters.width.toString()}
								onChange={handleWindowWidthChange}
							/>
						</label>
						<label>
							Window Height (m):{' '}
							<WeaveInput
								id="windowHeight"
								type="number"
								min={0}
								max={100}
								step="5"
								value={windowSizeInMeters.height.toString()}
								onChange={handleWindowHeightChange}
							/>
						</label>
					</div>
				)}
			</div>
		</div>
	);
};
